<template>
  <v-slide-y-transition mode="out-in">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 xl3 lg3 md5 sm8>
          <v-card class="elevation-12">
            <v-toolbar color="primary">
              <v-toolbar-title>mySuite Sign Up</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  prepend-icon="account_circle"
                  name="username"
                  v-model="selected.username"
                  v-validate="'required|min:3'"
                  :error-messages="errors.first('username')"
                  label="User Name"
                  type="text"
                ></v-text-field>
                <v-text-field
                  prepend-icon="person"
                  name="fullname"
                  v-model="selected.fullname"
                  v-validate="'required'"
                  :error-messages="errors.first('fullname')"
                  label="Full Name"
                  type="text"
                ></v-text-field>
                <v-text-field
                  prepend-icon="email"
                  v-model="selected.email"
                  name="email"
                  v-validate="'required|email'"
                  :error-messages="errors.first('email')"
                  label="Email"
                  type="text"
                ></v-text-field>

                <v-text-field
                  prepend-icon="vpn_key"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  :type="show1 ? 'text' : 'password'"
                  name="password"
                  v-model="selected.password"
                  v-validate="'required|min:8'"
                  :error-messages="errors.first('password')"
                  label="Password"
                  hint="At least 8 characters"
                  counter
                  @click:append="show1 = !show1"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" @click="save_Onclick">Sign Up</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-slide-y-transition>
</template>

<script>
import auth from "../functions/auth";
import common from "../functions/general";
import store2 from 'store2';

export default {
  name: "SignUpPage",
  data: () => {
    return {
      show1: false,
      selected: {
        username: "",
        password: "",
        fullname: "",
        email: ""
      }
    };
  },
  mounted() {
    store2(false);//
  },
  methods: {
    save_Onclick() {
      let self = this;
      this.$validator.validateAll().then(async result => {
        if (result) {
          let res = await auth.signup(self.selected);
          if (res.Status == 1) {
            window.location.href = "/home";
            // self.$router.push({ path: "/home" });
          } else {
            common.wMsgBox.Error(res.Description);
          }
        }
      });
    }
  }
};
</script>

<style>
</style>
